<template>
	<div>
		<insure-care-policy-info/>
		<paper-policies v-if="policies.length > 0"/>
		<new-quote/>
	</div>
</template>

<script>
// Widgets
import NewQuote from './Widgets/NewQuote.vue';
import InsureCarePolicyInfo from './Widgets/InsureCarePolicyInfo.vue';
import PaperPolicies from './Widgets/PaperPolicies';

import { mapGetters } from 'vuex';

export default {
	name: 'UMIASidebar',
	components: {
		NewQuote,
		InsureCarePolicyInfo,
		PaperPolicies,
	},
	computed: {
		...mapGetters('Policy', ['policies']),
	},
};
</script>